// v5.7.77 — Initialize Sentry FIRST so it can capture errors from
// any subsequent import (including App.js itself). No-op when
// REACT_APP_SENTRY_DSN is unset.
import "@/sentry.config";
// Product analytics (PostHog). No-op until REACT_APP_POSTHOG_KEY is set.
import "@/posthog.config";
// Google AdSense site-verification bootstrap. No-op until
// REACT_APP_ADSENSE_CLIENT_ID (ca-pub-...) is set — see lib/adsenseVerification.js.
import { initAdSenseVerification } from "@/lib/adsenseVerification";
// Monetag REMOVED (2026-07) — it served adult/low-quality creatives (brand +
// App Store risk). AdProvider (src/contexts/AdContext.js) now purges any legacy
// Monetag tags + push service worker on boot. Web monetizes only via the
// premium-aware in-app slots (Ezoic/AdSense/house).

import React from "react";
import ReactDOM from "react-dom/client";
// Self-hosted fonts via @fontsource — no external Google Fonts request, so the
// static-host CSP needs no fonts.googleapis.com/gstatic.com allowance and ZAP's
// "SRI missing" finding on the Google stylesheet is eliminated.
import "@fontsource-variable/fraunces/standard.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@/index.css";
import "@/lib/toastSafe";
import App from "@/App";

// Inject AdSense verification head tags when configured (dormant otherwise).
initAdSenseVerification();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
